/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnstarShipmentRequest
 */
export interface UnstarShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UnstarShipmentRequest
     */
    shipmentId: string;
}

/**
 * Check if a given object implements the UnstarShipmentRequest interface.
 */
export function instanceOfUnstarShipmentRequest(value: object): value is UnstarShipmentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function UnstarShipmentRequestFromJSON(json: any): UnstarShipmentRequest {
    return UnstarShipmentRequestFromJSONTyped(json, false);
}

export function UnstarShipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnstarShipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
    };
}

  export function UnstarShipmentRequestToJSON(json: any): UnstarShipmentRequest {
      return UnstarShipmentRequestToJSONTyped(json, false);
  }

  export function UnstarShipmentRequestToJSONTyped(value?: UnstarShipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
    };
}

